import {Header} from "../components/dashboard/header";
import {Sidebar} from "../components/dashboard/sidebar";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import Cookies from "js-cookie";
import {useEffect, useState} from "react";
import {useUserStore} from "../store/userStore";
import {usePermify} from "@permify/react-role";

const DashboardLayout = ({ children }) => {
    const { user, isLoading, fetchCurrentUser, reset } = useUserStore();
    const [isChecking, setIsChecking] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    const { setUser } = usePermify();

    useEffect(() => {
        const checkAuth = async () => {
            const token = Cookies.get("token");
            if (!token) {
                navigate("/login", { replace: true });
                return;
            }
            try {
                const currentUser = await fetchCurrentUser();

                setUser({
                    id: currentUser.id,
                    roles: [],
                    permissions: currentUser.permissions,
                });
            } catch (error) {
                Cookies.remove("token");
                reset();
                navigate("/login", { replace: true });
            } finally {
                setIsChecking(false);
            }
        };

        checkAuth();
    }, [fetchCurrentUser, reset, setUser]);

    // Tant que le mot de passe par défaut n'a pas été changé, seul l'écran de profil est accessible.
    useEffect(() => {
        if (user?.mustChangePassword && location.pathname !== "/dashboard/profile") {
            navigate("/dashboard/profile", { replace: true });
        }
    }, [user, location.pathname, navigate]);

    if (isLoading || isChecking) {
        return (
            <div className="h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (!user) {
        return null; // ou un redirect
    }


    return (
        <div className="h-screen flex flex-col bg-gray-50">
            <Header />

            <div className="flex flex-1 pt-16">
                <Sidebar />

                <div className="flex-1 min-w-0 p-6 max-w-7xl mx-auto">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default DashboardLayout;
